import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import classNames from 'classnames';
import styles from './WizardStepLayout.module.scss';

const WizardStepLayout = ({ 
  children, 
  title, 
  description, 
  maxWidth = 'medium',
  noMaxWidth = false,
}) => {
  const rootClasses = classNames(styles.root, {
    [styles.narrow]: maxWidth === 'narrow',
    [styles.wide]: maxWidth === 'wide',
    [styles.noMaxWidth]: noMaxWidth,
  });

  return (
    <Box className={rootClasses}>
      {(title || description) && (
        <Box className={styles.header}>
          {title && (
            <Typography variant="h4" className={styles.title} component="h1">
              {title}
            </Typography>
          )}
          {description && (
            <Typography variant="body1" className={styles.description}>
              {description}
            </Typography>
          )}
        </Box>
      )}
      <Box className={styles.content}>
        {children}
      </Box>
    </Box>
  );
};

WizardStepLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  maxWidth: PropTypes.oneOf(['small', 'medium', 'wide']),
  noMaxWidth: PropTypes.bool,
};

export default WizardStepLayout;
